import React from 'react';
import { IRankList } from './interfaces';
import { Typography } from '@mui/material';
import { SidebarPanel } from '../SidebarPanel';
import { useNavigate } from 'react-router';
import { SidebarButton } from '../SidebarButton';

export const RankList: React.FC<IRankList> = ({
  title,
  ranking,
}): JSX.Element => {
  const navigate = useNavigate();

  return (
    <SidebarPanel title={title ?? 'Klassement'}>
      <table cellPadding="0" cellSpacing="0" width="100%">
        <thead>
          <tr>
            <td width="30px">
              <Typography fontSize=".8rem" fontWeight="bold">
                Pos.
              </Typography>
            </td>
            <td>
              <Typography fontSize=".8rem" fontWeight="bold">
                Naam
              </Typography>
            </td>
            <td align="center" width="30px">
              <Typography fontSize=".8rem" fontWeight="bold">
                Punten
              </Typography>
            </td>
          </tr>
        </thead>
        <tbody>
          {ranking.map((rank) => (
            <tr key={rank.position}>
              <td>
                <Typography fontSize=".8rem">{rank.position}.</Typography>
              </td>
              <td>
                <Typography fontSize=".8rem">{rank.name}</Typography>
              </td>
              <td align="center">
                <Typography fontSize=".8rem">{rank.score}</Typography>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <SidebarButton
        onClick={() => navigate('/competitions/current/22')}
        sx={{
          mt: 1,
        }}
      >
        Toon alles
      </SidebarButton>
    </SidebarPanel>
  );
};
